module.exports={
	"Scope": "ObservationManifest-List",
	"CoreEntity": "ObservationManifest",
	"TitleTemplate": "Observation Manifests",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ObsManifestListName",
			"PictDashboard": {}
		},
		"DisplayName":
		{
			"Name": "Display Name",
			"Hash": "ObsManifestListDisplayName",
			"PictDashboard": {}
		},
		"Category":
		{
			"Name": "Category",
			"Hash": "ObsManifestListCategory",
			"PictDashboard": {}
		}
	}
}
